import { getQueryStringParameter } from '../../../helpers';
import { setUpSmallInvestorFields } from '../risks_step';

$(() => {
  const $form = $('form#legal-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'risks') {
    return;
  }

  setUpSmallInvestorFields($form);
});
